// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter[data-v-3394f0d8] {\n  bottom: 90px;\n}\n.sticky-col-bg[data-v-3394f0d8] {\n  background-color: #ffffff;\n}\ntr:hover .sticky-col-bg[data-v-3394f0d8] {\n  background-color: #f8f9fa;\n}", ""]);
// Exports
module.exports = exports;
